// Generated file: do not edit manually

export const cefRed = '#d02239';
export const cefRedHover = '#b6132b';
export const black = '#000';
export const white = '#fff';
export const mainTextColor = '#191919';
export const secondaryTextColor = '#595959';
export const grey3 = '#f7f7f7';
export const grey5 = '#f2f2f2';
export const grey10 = '#e5e5e5';
export const grey30 = '#b2b2b2';
export const grey50 = '#7f7f7f';
export const grey60 = '#757575';
export const grey70 = '#4c4c4c';
export const ctaGreen = '#207600';
export const success = '#1e9022';
export const information = '#eac80c';
export const error = '#d41f3a';
export const cefPromoOrange = '#f39200';
export const cefPromoTeal = '#007495';
export const cefPromoPurple = '#6a2e5e';
export const cefPromoGreen = '#37954a';
export const cefPromoRed = '#d02239';
export const headingFont = '"Barlow Condensed", Arial, Helvetica, sans-serif';
export const semiCondensedFont =
  '"Barlow Semi Condensed", Arial, Helvetica, sans-serif';
export const bodyFont = '"Barlow", Arial, Helvetica, sans-serif';
export const phoneSmall = '360px';
export const phoneLarge = '480px';
export const tabletSmall = '768px';
export const tabletLarge = '980px';
export const desktopSmall = '1025px';
export const desktopMedium = '1120px';
export const desktopLarge = '1200px';
